export enum APPROVAL {
    PENDING = 1,
    // REVISI = 2,
    REJECTED = 3,
    APPROVED = 4
}